import api from './api';

export type Channel = 'lts' | 'stable' | 'beta';

export interface ReleaseAdoptionRow {
  build_uuid: string;
  name: string;
  version: string;
  channel: Channel;
  is_active: boolean;
  sessions_24h: number;
}

export interface ChannelSummary {
  channel: Channel;
  builds_total: number;
  builds_active: number;
  sessions_24h_total: number;
}

export interface ReleaseAdoptionReport {
  total_sessions_24h: number;
  rows: ReleaseAdoptionRow[];
  channels: ChannelSummary[];
}

export async function getAdoption(
  name = '',
  channel: Channel | '' = '',
  topN = 20,
): Promise<ReleaseAdoptionReport> {
  const resp = await api.get<ReleaseAdoptionReport>('/admin/releases/adoption', {
    params: {
      name: name || undefined,
      channel: channel || undefined,
      top_n: topN,
    },
  });
  return resp.data;
}

export interface RollbackResult {
  id: string;
  name: string;
  version: string;
  channel: Channel;
  is_active: boolean;
  text_hash_sha256: string;
  exe_path_hint: string;
  notes: string;
  activated_at: string;
}

export async function rollbackBuild(uuid: string): Promise<RollbackResult> {
  const resp = await api.post<RollbackResult>(`/admin/releases/${uuid}/rollback`);
  return resp.data;
}
